import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/store/store';
import { getRelativeGetStore } from '~/store/utils';
import { State } from './models';

const initialState: Partial<State> = {};

export const chooseYourPlan = createSlice({
  name: 'chooseYourPlan',
  initialState,
  reducers: {},
});

export const getStore = getRelativeGetStore<Partial<State>>((store: RootState) => store.chooseYourPlan);

export const {} = chooseYourPlan.actions;

export default chooseYourPlan.reducer;
